module.exports = __webpack_public_path__ + "img/btn1.32eb8522.png";